module.exports = __webpack_public_path__ + "static/media/most-clean-sheets.f18b37eb.png";